import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'
import { TAB_CUSTOMER_MAILING_LIST, TAB_CUSTOMER_PRESS_REVIEW, TAB_CUSTOMER_USER } from '~/constants/tab/customer/tab.constants'

const base = `${BASE_URL_SETTING}/customer`

export const SETTINGS_CUSTOMER: Route = {
  path: base
}

export const SETTINGS_CUSTOMER_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_CUSTOMER_EDIT: Route = {
  path: `${base}/{id}`
}

export const SETTINGS_CUSTOMER_EDIT_VIEW_LIST_USER: Route = {
  path: `${base}/{id}?tab=${TAB_CUSTOMER_USER}`
}

export const SETTINGS_CUSTOMER_EDIT_VIEW_LIST_PRESS_REVIEW: Route = {
  path: `${base}/{id}?tab=${TAB_CUSTOMER_PRESS_REVIEW}`
}

export const SETTINGS_CUSTOMER_EDIT_VIEW_MAILING_LIST: Route = {
  path: `${base}/{id}?tab=${TAB_CUSTOMER_MAILING_LIST}`
}
